import React from "react";
import { useAuth } from "@/lib/auth";
import HolidayPromptPopup from "@/components/HolidayPromptPopup";

/**
 * Mostra il popup festività solo a utenti loggati. Wrapper minimale.
 */
export default function AuthedHolidayPopup() {
  const { user } = useAuth();
  if (!user) return null;
  return <HolidayPromptPopup />;
}
